import _ from 'lodash'
import moment from 'moment'

type StepInterval = 15 | 30 | 60

export const createTimeSlots = (
  step: StepInterval,
  referenceTime: moment.Moment | undefined | null = null
): Array<moment.Moment> => {
  const rangeInMinutes = 1440
  const startTime = (
    referenceTime != null ? referenceTime.clone() : moment()
  ).startOf('day')
  const slots = _.times(rangeInMinutes / step, (index) => {
    return startTime.clone().add(index * step, 'minute')
  })
  return slots
}

export const parseTime = (
  timeString?: string | null
): moment.Moment | undefined | null => {
  const time = moment(timeString!, ['hh:mm A', 'HH:mm a'], false)
  return time.isValid() ? time : null
}
